import { Form, Row, Col, Input, DatePicker } from "antd";
import React from "react";
import BannerCard from "../../../common/components/BannerCard";
import InputCurrency from "../../../common/components/InputCurrency";
import { defaultDateFormat } from "../../../common/constants/Helpers";

const CaseBalanceViolationDetail = ({ ...props }) => {
  const { form } = props;
  return (
    <BannerCard title="Violations Type">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="PLAN_TYPE" label="Plan Type">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="VIOLATION_PAY_PLAN" label="Pay Plan">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="VIOLATION_NEXT_PAY_DATE" label="Next Pay Date">
              <DatePicker style={{ width: "100%" }} format={defaultDateFormat} disabled />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="VIOLATION_NEXT_PAY_AMOUNT" label="Next Pay Amount">
              <InputCurrency readOnly style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="VIOLATION_LAST_PAY_DATE" label="Last Pay Date">
              <DatePicker style={{ width: "100%" }} format={defaultDateFormat} disabled />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="VIOLATION_LAST_PAY_AMOUNT" label="Last Pay Amount">
              <InputCurrency readOnly style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CaseBalanceViolationDetail;
